import * as React from "react";

export const IconForwardArrow = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16.0002 5.33301L14.1202 7.21301L21.5602 14.6663H5.3335V17.333H21.5602L14.1202 24.7863L16.0002 26.6663L26.6668 15.9997L16.0002 5.33301Z" fill="white"/>
  </svg>
);
